"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  MultiComboBoxTokenizer: true
};
exports.default = exports.MultiComboBoxTokenizer = void 0;
var _bind = _interopRequireDefault(require("classnames/bind"));
var _react = _interopRequireWildcard(require("react"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _keycode = _interopRequireDefault(require("../keycode/keycode"));
var _List = require("../List/List");
var _Overlay = require("../Overlay/Overlay");
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _useUniversalLayoutEffect = _interopRequireDefault(require("../utils/useUniversalLayoutEffect"));
var _listboxUtils = require("../List/_listboxUtils");
var _MultiComboBoxToken = require("./_MultiComboBoxToken");
var _MultiComboBoxTokenizer = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./MultiComboBoxTokenizer.css") : void 0);
var _MultiComboBoxTokenizer2 = require("./_MultiComboBoxTokenizer.types");
Object.keys(_MultiComboBoxTokenizer2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _MultiComboBoxTokenizer2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _MultiComboBoxTokenizer2[key];
    }
  });
});
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const CSS_BLOCK = 'sapcnqr-multicombobox-tokenizer';
const MultiComboBoxTokenizer = exports.MultiComboBoxTokenizer = /*#__PURE__*/_react.default.forwardRef((_props, ref) => {
  const addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  const props = addChildProps ? Object.assign(Object.assign({}, _props), addChildProps(MultiComboBoxTokenizer, _props)) : _props;
  const {
      className,
      closeLabel,
      disabled,
      onClose,
      itemKey = 'key',
      itemText = 'text',
      overflowTokenLabel,
      onOverflowTokenClick,
      overflowTokenRef,
      onKeyDown,
      reservedWidthForSiblings = 0,
      selectedOptions,
      readOnly,
      removeLabel,
      validationMessageState
    } = props,
    otherProps = __rest(props, ["className", "closeLabel", "disabled", "onClose", "itemKey", "itemText", "overflowTokenLabel", "onOverflowTokenClick", "overflowTokenRef", "onKeyDown", "reservedWidthForSiblings", "selectedOptions", "readOnly", "removeLabel", "validationMessageState"]);
  const classnames = _bind.default.bind(_MultiComboBoxTokenizer.default);
  const [parentContainerWidth, setParentContainerWidth] = (0, _react.useState)(0);
  const [tokenWidth, setTokenWidth] = (0, _react.useState)(new Map());
  const [overflowItems, setOverflowItems] = (0, _react.useState)([]);
  const [readOnlyPopperOpen, setReadOnlyPopperOpen] = (0, _react.useState)(false);
  const setRefs = (0, _react.useRef)(new Map()).current;
  const tokenizerRef = (0, _react.useRef)();
  const mergedRef = (0, _reactMergeRefs.default)([ref, tokenizerRef]);
  const getParentWidth = itemRef => {
    var _a, _b;
    return ((_b = (_a = itemRef === null || itemRef === void 0 ? void 0 : itemRef.current) === null || _a === void 0 ? void 0 : _a.parentNode) === null || _b === void 0 ? void 0 : _b.clientWidth) || 0;
  };
  const detectWrap = () => {
    const wrappedItems = [];
    let totalWidthOfTokens = 0;
    const maxWidthForTokens = parentContainerWidth - reservedWidthForSiblings;
    selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.forEach(child => {
      if (!child) return;
      const childKey = (0, _listboxUtils.reduceOption)(child, itemKey);
      const tokenDimensions = setRefs.get(childKey) ? setRefs.get(childKey).getBoundingClientRect() : 0;
      if (tokenDimensions.width > 0) {
        setTokenWidth(tokenWidth.set(childKey, tokenDimensions.width));
      }
      if (tokenWidth.get(childKey)) {
        totalWidthOfTokens += tokenWidth.get(childKey);
      }
      if (totalWidthOfTokens > maxWidthForTokens) {
        wrappedItems.push(child);
      }
    });
    return wrappedItems;
  };
  (0, _useUniversalLayoutEffect.default)(() => {
    if (parentContainerWidth > 0) {
      setOverflowItems(detectWrap());
    }
  }, [parentContainerWidth, selectedOptions]);
  const handleResize = () => {
    setParentContainerWidth(getParentWidth(tokenizerRef));
  };
  (0, _useUniversalLayoutEffect.default)(() => {
    handleResize();
  }, []);
  // runs on every resize
  (0, _react.useEffect)(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  });
  const classes = classnames(CSS_BLOCK, {
    [`${CSS_BLOCK}--disabled`]: disabled,
    [`${CSS_BLOCK}--readonly`]: readOnly,
    [`${CSS_BLOCK}--${validationMessageState}`]: validationMessageState
  }, className);
  const passChildProps = (child, childProps = {}) => {
    if (child.displayName === 'MultiComboBoxToken') {
      return {
        className: classnames(`${CSS_BLOCK}__token`, childProps.className),
        readOnly,
        disabled,
        validationMessageState
      };
    }
    return {};
  };
  const handleOverflowClick = e => {
    if (readOnly) {
      setReadOnlyPopperOpen(true);
    }
    if (!disabled && onOverflowTokenClick) {
      onOverflowTokenClick(e);
    }
  };
  const overflowToken = /*#__PURE__*/_react.default.createElement(_MultiComboBoxToken.MultiComboBoxToken, {
    key: "token-overflow",
    "data-nui-widgets": "token-overflow",
    overflow: true,
    onClick: handleOverflowClick,
    onKeyDown: e => {
      if (!disabled) {
        onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e, null);
      }
    },
    textProps: {
      ref: overflowTokenRef
    }
  }, overflowItems.length, " ", overflowTokenLabel);
  const renderTokens = () => {
    const tokenChildren = selectedOptions ? selectedOptions.filter(val => overflowItems.indexOf(val) === -1) : [];
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, tokenChildren.map(item => {
      if (!item) return null;
      const tokenKey = (0, _listboxUtils.reduceOption)(item, itemKey);
      return /*#__PURE__*/_react.default.createElement(_MultiComboBoxToken.MultiComboBoxToken, {
        removeLabel: removeLabel || closeLabel,
        key: `token-${tokenKey}`,
        ref: node => !node ? setRefs.delete(tokenKey) : setRefs.set(tokenKey, node),
        onClick: e => {
          if (!disabled && onClose) {
            onClose(e, item);
          }
        },
        onKeyDown: e => {
          if (!disabled) {
            onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e, item);
          }
        }
      }, (0, _listboxUtils.reduceOption)(item, itemText));
    }), !!overflowItems.length && !readOnly && overflowToken, !!overflowItems.length && readOnly && (/*#__PURE__*/_react.default.createElement(_Overlay.Overlay, {
      show: readOnlyPopperOpen,
      showArrow: true,
      targetComponent: overflowToken,
      widthSizingType: "minTarget",
      className: classnames(`${CSS_BLOCK}__popper`),
      offset: 10,
      focusManagerProps: {
        nextKeyCode: _keycode.default.codes.down,
        previousKeyCode: _keycode.default.codes.up
      }
    }, /*#__PURE__*/_react.default.createElement(_List.List, {
      className: classnames(`${CSS_BLOCK}__list`)
    }, selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.map(item => (/*#__PURE__*/_react.default.createElement(_List.List.Item, {
      key: (0, _listboxUtils.reduceOption)(item, itemKey)
    }, (0, _listboxUtils.reduceOption)(item, itemText))))))));
  };
  return /*#__PURE__*/_react.default.createElement(_AddChildPropsContext.AddChildPropsProvider, {
    value: passChildProps
  }, /*#__PURE__*/_react.default.createElement("div", Object.assign({}, otherProps, {
    className: classes,
    ref: mergedRef
  }), renderTokens()));
});
MultiComboBoxTokenizer.displayName = 'MultiComboBoxTokenizer';
var _default = exports.default = MultiComboBoxTokenizer;